import {useState, useEffect} from 'react';
import {usePreviewContext} from '../context/PreviewContext';
import {AccessService} from '../utils/AccessService';
import {LocalStorage} from '../utils/LocalStorage';

export const usePortalModules = () => {
    const {isPreview, previewModules} = usePreviewContext();
    const [modules, setModules] = useState(isPreview ? previewModules : null);

    useEffect(() => {
        if (isPreview) {
            setModules(previewModules);
            return;
        }
        const userId = LocalStorage.fetchUserId();
        if (!userId) return;
        AccessService.GetUserModules(userId, (data) => {
            setModules(data.modules || []);
        }, () => {
            setModules([]);
        });
    }, [isPreview, previewModules]);

    return modules;
};
